import { observable, action} from 'mobx';
import {shipment, cropPlan, date, time, offers, news} from './index';
import cropPlanSettings from './cropPlanSettings.json'
import cultureSettings from './cultureSettings.json'

export default class DateStore {

    constructor(){
        // this.initialDay = new Date(2017, 7, 1, 0, 0, 0);
        this.day = new Date(2019, 6, 9, 0, 0, 0);
        this.scheduleReception = {
            truck:[],
            train:[]
        };
        this.forecastInitialization();
        this.setCurrentDay();
        this.compositionFormation = false;
    }

    @observable compositionFormation;
    @observable day;
    @observable forecast;
    @observable weather;
    @observable temp;
    @observable scheduleReception;

    @action setDay(){
        this.day.setDate(this.day.getDate() + 1);
        offers.offers.filter(item=>(item.status==="new" && item.date<this.day)).forEach((item)=>{
            item.setStatus("failed")
        })
    }
    @action setCompositionFormation(culture){
        if(!this.compositionFormation && culture){
            this.compositionFormationCulture=culture;
            this.compositionFormation = true;
        }
    }
    @action setTemp(){
        let min = Math.floor(Math.random()*(14))+6;
        let max = min + Math.floor(Math.random()*(3))+1;
        return {min, max}
    }

    @action setScheduleReception() {
        this.setDay();
        shipment.filterOutputTransport();

        let allCultures={};
        for (let key in cropPlanSettings){
            let cropPlanDate = new Date(cropPlanSettings[key].date);
            let delta = Math.floor((this.day - cropPlanDate)/ 1000 / 60 / 60/ 24);
            if(delta >= 0 && delta<cropPlan.scenario[key].length){
                allCultures[key] = cropPlan.scenario[key][delta];
                cropPlan.dayPlan[key]= cropPlan.scenario[key][delta];
                cropPlan.weekPlan[key]=0;
                cropPlan.monthPlan[key]=0;
                for(let i=0;i<7;i++){
                    if((delta+i)<= cropPlan.scenario[key].length-1)
                    cropPlan.weekPlan[key]+=cropPlan.scenario[key][delta+i]
                }
                for(let i=0;i<30;i++){
                    if((delta+i)<= cropPlan.scenario[key].length-1)
                        cropPlan.monthPlan[key]+=cropPlan.scenario[key][delta+i]
                }
            }else {
                if (delta > -7 && delta < 0) {
                    cropPlan.weekPlan[key]=0;
                    cropPlan.monthPlan[key]=0;
                    for(let i=0;i<7;i++){
                        if(delta+i >=0)
                        if((delta+i)<= cropPlan.scenario[key].length-1)
                            cropPlan.weekPlan[key]+=cropPlan.scenario[key][delta+i]
                    }
                    for(let i=0;i<30;i++){
                        if(delta+i >=0)
                        if((delta+i)<= cropPlan.scenario[key].length-1)
                            cropPlan.monthPlan[key]+=cropPlan.scenario[key][delta+i]
                    }
                } else {
                    if(delta > -30 && delta<0){
                        cropPlan.monthPlan[key]=0;
                        for(let i=0;i<30;i++){
                            if(delta+i >=0)
                            if((delta+i)<= cropPlan.scenario[key].length-1)
                                cropPlan.monthPlan[key]+=cropPlan.scenario[key][delta+i]
                        }
                    }
                }
            }
        }

        let schedule = {
            truck:[],
            train:[]
        };
        let matches;
        let amountTruck ={};
        for(let key in allCultures){
                if(allCultures[key]) offers.addNewOffer(allCultures[key],key);
                amountTruck[key] = Math.floor(allCultures[key]/(20*cultureSettings[key].volume));
                while (amountTruck[key] > 0){
                    let truckGroup = Math.floor(Math.random() * (10 - 5)) + 5;
                    if (truckGroup > amountTruck[key]){
                        truckGroup = amountTruck[key];
                    }
                    let waste = Math.floor(cultureSettings[key].baseWaste + Math.floor(Math.random() * (cultureSettings[key].critWaste - cultureSettings[key].baseWaste)*1.3/2)*2);
                    let moisture = Math.floor(cultureSettings[key].baseMoisture +  Math.floor(Math.random() * ((cultureSettings[key].critMoisture-cultureSettings[key].baseMoisture))/2)*2  + (this.weather === 1 ? Math.random()*(cultureSettings[key].critMoisture-cultureSettings[key].baseMoisture)*0.3: 0));
                    amountTruck[key]-=truckGroup;

                    let result = Math.floor(Math.random()*(time.dayLength))+1;
                    matches = schedule.truck.findIndex((element) => {
                        if(element.time === result){
                            return element;
                        }
                        return null;
                    });
                    if (matches !== -1) {
                        schedule.truck[matches].item += truckGroup;
                    }else {
                        schedule.truck.push({item: truckGroup, time: result, culture: key, waste, moisture});
                    }
                }
        }

        schedule.truck.sort((a,b)=>{
            return b.time - a.time;
        });
        schedule.train.sort((a,b)=>{
            return b.time - a.time;
        });
        return schedule;
    }

    @action setCurrentDay() {
        if(this.compositionFormation ) {
            if(Math.random()*100 > 20) {
                this.compositionFormation = false;
                let dayOutcame = new Date(this.day.getFullYear(), this.day.getMonth(), this.day.getDate(), 0, 0, 0);
                let dayIncome = new Date(this.day.getFullYear(), this.day.getMonth(), this.day.getDate(), 0, 0, 0);
                dayOutcame = dayOutcame.setDate(dayOutcame.getDate() + 6 + Math.floor(Math.random() * 3));
                shipment.addOutputTransport(
                    'train',
                    this.compositionFormationCulture,
                    dayIncome,
                    new Date(dayOutcame),
                    3599 * cultureSettings[this.compositionFormationCulture].volume,
                    cultureSettings[this.compositionFormationCulture].baseWaste,
                    cultureSettings[this.compositionFormationCulture].baseMoisture
                )
            }else{
                news.addShipmentErrorMessage()
            }
        }

        this.weather = this.forecast[0].weather;
        this.temp =this.forecast[0].temp;

        this.forecast = [
            {
                day:(this.day.getDate() === 31 ? 1 : this.day.getDate() + 1),
                temp: this.forecast[1].temp,
                weather: this.forecast[1].weather
            },
            {
                day:(this.day.getDate() > 29 ? this.day.getDate() - 29 : this.day.getDate() + 2),
                temp:this.forecast[2].temp,
                weather: this.forecast[2].weather
            },
            {
                day:(this.day.getDate() > 28 ? this.day.getDate() - 28 : this.day.getDate() + 3),
                temp:this.setTemp(),
                weather: Math.floor(Math.random() * 3)
            }
        ];

        this.scheduleReception = this.setScheduleReception();
    }


    @action forecastInitialization(){
        this.forecast = [
            {
                day: this.day.getDate()+1,
                temp:this.setTemp(),
                weather: Math.floor(Math.random() * 3)
            },
            {
                day:this.day.getDate()+2,
                temp:this.setTemp(),
                weather: Math.floor(Math.random() * 3)
            },
            {
                day:this.day.getDate()+3,
                temp:this.setTemp(),
                weather: Math.floor(Math.random() * 3)
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/shared/stores/date.js